module.exports = __webpack_public_path__ + "img/heart.b0f2cc29.svg";